import * as React from "react";
import { ListItemPicker } from "./listItemPicker";
import { ITag, Label } from "@fluentui/react";
import { ILookupInputProps } from "../../interfaces/ILookupInputProps";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { logger } from "../../../../utilities/logger";
import { getListItemsById } from "../../services/SharePointRestServices";
import authModule from "../../../../utilities/AuthModule";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

const LookupMulti: React.FunctionComponent<ILookupInputProps> = ({
  displayName,
  isRequired,
  updateInputValidationStatus,
  inputValidator,
  webUrl,
  error,
  listId,
  itemLimit,
  columnInternalName,
  inputValue
}: ILookupInputProps) => {

  const languageStrings = React.useContext(LanguageContext);
  const [defaultSelectedItems, setDefaultSelectedItems] = React.useState<ITag[]>([]);

  React.useEffect(() => {
    if (inputValue?.value && Array.isArray(inputValue.value)) {
      (async () => {
        try {
          const listItems: ITag[] = await getListItemsById(await authModule.getSharePointAccessToken(), webUrl, listId, columnInternalName, inputValue.value);
          if (listItems?.length > 0) {
            setDefaultSelectedItems(listItems);
          }
          else {
            setDefaultSelectedItems([]);
          }
        } catch (error) {
          logger(error, "lookupMulti.tsx (useEffect)");
        }
      })();
    } else {
      setDefaultSelectedItems([]);
    }
  }, [inputValue?.value]);

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "lookupMulti.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const onSelectedItem = (data: { key: string; name: string }[]) => {
    updateInputValidationStatus(
      inputValidator.validate(
        data.map(item => item.key)
      )
    );
  }

  // const displayError = () => {
  //   return error ? (
  //     <>
  //       <span style={{ color: "red" }}>You need to select a value</span>
  //     </>
  //   ) : null;
  // };

  const lookupPicker = (
    <>
      {displayName && <Label required={isRequired()}>{displayName}</Label>}
      <ListItemPicker
        disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
        defaultSelectedItems={defaultSelectedItems}
        listId={listId}
        columnInternalName={columnInternalName}
        webUrl={webUrl}
        itemLimit={itemLimit}
        suggestionsHeaderText={languageStrings.SuggestedValues}
        onSelectedItem={onSelectedItem}
        substringSearch={true}
      />
    </>
  );

  return (
    <>
      {lookupPicker}
      {/* {displayError()} */}
    </>
  );
};

export default LookupMulti;